import { render, staticRenderFns } from "./ChainBPBarHeadBlockProducer.vue?vue&type=template&id=aea7176c"
import script from "./ChainBPBarHeadBlockProducer.vue?vue&type=script&lang=js"
export * from "./ChainBPBarHeadBlockProducer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports